import { useState, useCallback, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import s from './MLTooltip.module.css';

function MLTooltip({
  children,
  content,
  placement = 'bottom',
  interactive = true,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const handleUserKeyPress = useCallback((event) => {
    const { key } = event;
    if (key === 'Escape') {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    if (open) {
      window.addEventListener('keydown', handleUserKeyPress);
      return () => {
        window.removeEventListener('keydown', handleUserKeyPress);
      };
    }
  }, [handleUserKeyPress, open]);

  return (
    <Tooltip
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      classes={{
        tooltip: s.tooltip,
        arrow: s.tooltipArrow,
      }}
      title={disabled ? '' : content}
      placement={placement}
      interactive={interactive}
      arrow
    >
      {children}
    </Tooltip>
  );
}

export default MLTooltip;
